import { observer } from "mobx-react";
import React from "react";
import styles from "./calendarCell.css";
import { getTimeString } from "@fidget/common/utils/timeFormatter";

interface Props {
  start: Date;
  duration: number;
}

export const CalendarCellMeetingTime = observer(({ start, duration }: Props) => {
  const startTime = getTimeString(start.getTime());
  const endTime = getTimeString(start.getTime() + duration);
  return (
    <div className={styles["meeting-time"]}>
      {startTime} - {endTime}
    </div>
  );
});
